import { nip19 } from "nostr-tools";

/** Validate an nsec secret-key string. */
export function validateNsec(nsec: string): boolean {
  try {
    const decoded = nip19.decode(nsec.trim());
    return decoded.type === "nsec";
  } catch {
    return false;
  }
}

/** Validate a NIP-46 bunker:// connection URI. */
export function validateBunkerUri(uri: string): boolean {
  try {
    const url = new URL(uri.trim());
    return url.protocol === "bunker:";
  } catch {
    return false;
  }
}
